import React, { useState } from "react";
import { getCachedScript } from "../../utils/scriptCache.js";
import { loadLocalModule } from "../../utils/nodeLoader.js";

// Node modules of the one-step export (src/utils/nodeModules), passed to buildPremiereTemplate.
const TEMPLATE_MODULES = {
  buildPremiereProject: ["buildPremiereProject", "buildPremiereProject"],
  readScene: ["buildPremiereProject", "readScene"],
  addShapeLayerEffects: ["buildPremiereProject", "addShapeLayerEffects"],
  traceShapeLayers: ["traceShapeLayers", "traceShapeLayers"],
  importTextLayers: ["importTextLayers", "importTextLayers"],
  importShapeLayers: ["importShapeLayers", "importShapeLayers"],
  importMaskPath: ["importMaskPath", "importMaskPath"],
  importColors: ["importColors", "importColors"],
  importTrackMatte: ["importTrackMatte", "importTrackMatte"],
  restoreTrackItemName: ["RestoreTrackItemName", "restoreTrackItemName"],
  importProjectStructure: ["importProjectStructure", "importProjectStructure"],
  importLockLayer: ["ImportLockLayer", "importLockLayer"],
  normalizeAudioTrackItem: ["NormalizeAudioTrackItem", "normalizeAudioTrackItem"],
  deleteNullTrack: ["DeleteNullTrack", "deleteNullTrack"],
};

const loadTemplateModules = () => {
  const loaded = {};
  const modules = {};
  for (const [key, [file, name]] of Object.entries(TEMPLATE_MODULES)) {
    loaded[file] = loaded[file] || loadLocalModule(file);
    if (!loaded[file] || typeof loaded[file][name] !== "function") {
      throw new Error(`Module ${file} is not available`);
    }
    modules[key] = loaded[file][name];
  }
  return modules;
};

// "Export Premiere (Beta)": one step, no options. AE prepares the project and writes the scene
// (ae2PremiereTemplate), then Node builds info.output
// ("<aep folder>/Premiere Pro Template/Premiere Pro/<name>.prproj") with collected footage.
function ExportPremiereBeta({ selectedTag, buttonTags, generateButtonTags, button, buttonViewMode }) {
  const [isExporting, setIsExporting] = useState(false);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  const exportTemplate = () => {
    if (isExporting) return;
    if (!getCachedScript()) {
      alert("After Effects script is not loaded");
      return;
    }
    setIsExporting(true);

    window.jsx.evalScript("run(ae2PremiereTemplate());", (result) => {
      try {
        if (!result || result === "false") return;
        let info;
        try {
          info = JSON.parse(result);
        } catch (error) {
          throw new Error(`After Effects returned: ${result}`);
        }
        const builder = loadLocalModule("buildPremiereTemplate");
        if (!builder) throw new Error("Module buildPremiereTemplate is not available");
        const report = builder.buildPremiereTemplate({ bundle: info.bundle, outputPath: info.output }, loadTemplateModules());
        const message = report.errors.length
          ? `Premiere template created with errors:\n${report.errors.join("\n")}`
          : `Premiere template created:\n${info.output}`;
        alert(message);
        // the folder of the .prproj
        const folder = info.output.replace(/[\\/][^\\/]*$/, "");
        window.__adobe_cep__.evalScript(`Folder(${JSON.stringify(folder)}).execute()`, () => {});
      } catch (error) {
        alert(`Export failed: ${error.message}`);
      } finally {
        setIsExporting(false);
      }
    });
  };

  return (
    <li className={`button-card button-card--${buttonViewMode || "list"}`} onClick={exportTemplate}>
      <div className="button-card__icon">
        <div dangerouslySetInnerHTML={{ __html: button.icon }} />
      </div>
      <div className="button-card__title">{isExporting ? "Exporting..." : button.name}</div>
      {generateButtonTags()}
    </li>
  );
}

export default ExportPremiereBeta;
